import { ReactNode } from 'react';
import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button, HelpIcon, PopoverMenu, PopoverMenuItem, UserVoiceIcon, usePopoverMenu } from '@frontend/design-system';

type HelpMenuProps = {
  feedbackUrl?: string;
  helpUrl?: string;
};

export const HelpMenu = ({ feedbackUrl, helpUrl }: HelpMenuProps) => {
  const { t } = useTranslation('analytics');

  const { getMenuProps, getTriggerProps } = usePopoverMenu({
    placement: 'bottom-end',
  });

  if (!feedbackUrl && !helpUrl) {
    return null;
  }

  return (
    <>
      <Button
        {...getTriggerProps()}
        iconName='more'
        label={t('More')}
        size='large'
        trackingId='analytics-more-menu'
        variant='secondary'
      />
      <PopoverMenu {...getMenuProps()}>
        {feedbackUrl && (
          <PopoverMenuItem
            onClick={() => {
              window.open(feedbackUrl, '_blank');
            }}
            trackingId='analytics-feedback'
          >
            <UserVoiceIcon />
            {t('Feedback')}
          </PopoverMenuItem>
        )}

        {helpUrl && (
          <PopoverMenuItem
            onClick={() => {
              window.open(helpUrl, '_blank');
            }}
            trackingId='analytics-help'
          >
            <HelpIcon />
            {t('Help')}
          </PopoverMenuItem>
        )}
      </PopoverMenu>
    </>
  );
};

const HelpMenuWrapper = ({ children }: { children: ReactNode }) => (
  <div
    css={css`
      align-items: center;
      display: flex;
      gap: ${theme.spacing(1)};
    `}
  >
    {children}
  </div>
);

HelpMenu.Wrapper = HelpMenuWrapper;
